import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Calendar } from 'primereact/calendar';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';
import servicioObjetos from '../servicio/ServicioObjetos';
import servicioHttp from "../servicio/ServicioHttp";
import servicioFormatos from '../servicio/ServicioFormatos';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import servicioArchivos from '../servicio/ServicioArchivos';
const SELECCIONE = { label: "SELECCIONE", value: null };
export default class CapturaEditaInsidencia extends Component {
    constructor() {
        super();
        this.state = {
            mostrarCalendarios: true,
            idsenube: 0,
            indexMovimiento: null,
            movimietosCap: {},
            captura: {},
            registrosPatronales: [],
            registroPatronal: {},
            errorRegistroPatronal: {},
            errores: {},
            incidenciasCapturadas: [],
            incidenciasGuardadas: [],
            incidenciasSeleccionados: [],
            tiposInsidencias: [
                { label: "* SELECCIONAR", value: null },
                { label: "AUSENTISMO", value: "11" },
                { label: "INCAPACIDAD", value: "12" },],
            trabajadores: []
        };
    }
    componentDidMount() {
        this.obtenerRegistrosPatronales();
    }
    obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [SELECCIONE];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { captura } = this.state;
            captura.registroPatronal = SELECCIONE.value;
            this.setState({ registrosPatronales: newArray, captura: captura });
        }).catch(error => {

        });
    };
    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
        if (event.target.id === "captura.registroPatronal" && !servicioObjetos.esObjetoVacio(event.target.value)) {
            this.cargarTrabajadores(event.target.value);
        }

    }

    cargarTrabajadores = (id) => {
        let { captura } = this.state;
        servicioHttp.consumirPostHttp('trabajador/consulta_por_empresa_registro_patronal.json', { id: id }).then(response => {
            captura['nss'] = null;
            this.setState({ trabajadores: response.data.lista, captura });
        }).catch(error => {

        });
    }
    plantillaChecBox = (rowData, column) => {
        return <Checkbox inputId="cb1" value={rowData} onChange={this.validarRegistrosObjetos} checked={this.state.incidenciasSeleccionados.indexOf(rowData) !== -1} ></Checkbox>


    }
    plantillaChecBoxBorrar = (rowData, column) => {
        return <Checkbox inputId="cb1" value={rowData} onChange={this.validarRegistrosObjetos} checked={this.state.incidenciasSeleccionados.indexOf(rowData) !== -1} ></Checkbox>
    }
    validarRegistrosObjetos = (e) => {
        let { incidenciasSeleccionados } = this.state;
        let respuesta = incidenciasSeleccionados.findIndex(element => element === e.value);
        if (e.checked) {
            if (respuesta === -1) {
                incidenciasSeleccionados.push(e.value);
            }
        } else {
            incidenciasSeleccionados.splice(respuesta, 1);
        }
        this.setState({ incidenciasSeleccionados: incidenciasSeleccionados });
    }

    eliminarDelaListaCaptura = () => {
        let { incidenciasCapturadas, incidenciasSeleccionados } = this.state;
        try {
            incidenciasCapturadas.forEach(movimientoC => delete movimientoC.errores);
            if (incidenciasSeleccionados.length === 0)
                throw new Error("No has seleccionado un movimiento");
            incidenciasSeleccionados.forEach(movimientoS => {
                let index = incidenciasCapturadas.findIndex(movimentoCap => movimentoCap === movimientoS);
                if (index !== -1)
                    incidenciasCapturadas.splice(index, 1);
            })
            this.setState({ incidenciasCapturadas, indexMovimiento: null, incidenciasSeleccionados: [] });
            this.growl.show({ severity: 'success', summary: 'Aviso', detail: "Movimiento eliminado de la tabla con éxito", life: 20000 });
        } catch (error) {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: error.message, life: 3000 });
        }


    }
    editarDatos = () => {
        let { incidenciasCapturadas, incidenciasSeleccionados, trabajadores } = this.state;
        try {
            if (incidenciasSeleccionados.length === 0)
                throw new Error("No has seleccionado un movimiento");

            if (incidenciasSeleccionados.length > 1)
                throw new Error("Para editar, solo debes seleccionar un movimiento");
            incidenciasCapturadas.forEach(movimientoC => delete movimientoC.errores);
            incidenciasSeleccionados.forEach(movimientoS => {
                let index = incidenciasCapturadas.findIndex(movimentoCap => movimentoCap === movimientoS);
                if (index !== -1) {
                    let objetoeditar = JSON.parse(JSON.stringify(incidenciasCapturadas[index]));
                    console.log(objetoeditar);
                    var timestamp = Date.parse(objetoeditar.fechaIncidencia);
                    var dateObject = new Date(timestamp);
                    objetoeditar.fechaIncidencia = dateObject;

                    let lista_nss = trabajadores.filter(obj => {
                        return obj.value === objetoeditar.nss;
                    });
                    if (lista_nss[0] != null)
                        objetoeditar['nss'] = lista_nss[0];
                    else
                        objetoeditar['nss'] = null;
                    console.log(objetoeditar);
                    this.setState({ captura: objetoeditar, indexMovimiento: index });
                }
            })
        } catch (error) {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: error.message, life: 3000 });
        }

    }
    agregarCapturados = () => {
        let { captura, incidenciasCapturadas, indexMovimiento, registrosPatronales } = this.state;
        let errores = this.validarFormulario(captura);
        this.setState({ errores: errores });
        if (servicioObjetos.esObjetoVacio(errores)) {
            let rp = registrosPatronales.find(elemen => elemen.value === captura.registroPatronal);
            servicioHttp.consumirPostHttp('incidencia/validar_fechas.json', { registroPatronal: rp, tipoIncidencia: captura.tipoIncidencia, nss: captura.nss, fechaIncidencia: captura.fechaIncidencia, folioIncapacidad: captura.folioIncapacidad, diaAplicado: captura.diaAplicado }).then(response => {
                if (!response.data.error) {
                    if (indexMovimiento != null) {
                        let bandera = false;
                        for (let i = 0; i < incidenciasCapturadas.length; i++) {
                            if (incidenciasCapturadas[i].registroPatronal.value === captura.registroPatronal && incidenciasCapturadas[i].nss === captura.nss) {
                                let fecha1 = moment(incidenciasCapturadas[i].fechaIncidencia);
                                let fecha2 = moment(captura.fechaIncidencia);
                                let dias = fecha2.diff(fecha1, 'day');
                                if (dias < incidenciasCapturadas[i].diaAplicado) {
                                    bandera = true;
                                }
                            }
                        }
                        if (bandera === false) {
                            incidenciasCapturadas[indexMovimiento].registroPatronal = captura.rp;
                            incidenciasCapturadas[indexMovimiento].tipoIncidencia = captura.tipoIncidencia;
                            incidenciasCapturadas[indexMovimiento].nss = captura.nss;
                            incidenciasCapturadas[indexMovimiento].fechaIncidencia = captura.fechaIncidencia;
                            incidenciasCapturadas[indexMovimiento].folioIncapacidad = captura.folioIncapacidad;
                            incidenciasCapturadas[indexMovimiento].diaAplicado = captura.diaAplicado;
                        } else {
                            this.growl.show({ severity: 'error', summary: 'Aviso', detail: "No se puede registrar la incidencia porque ya existe con la fecha especificada", life: 3000 });
                        }
                    } else {
                        let bandera = false;
                        for (let i = 0; i < incidenciasCapturadas.length; i++) {

                            if (incidenciasCapturadas[i].registroPatronal === captura.registroPatronal && incidenciasCapturadas[i].nss === captura.nss && new Date(incidenciasCapturadas[i].fechaIncidencia).getTime() === new Date(captura.fechaIncidencia).getTime()) {
                                bandera = true;
                            }
                            if (incidenciasCapturadas[i].registroPatronal === captura.registroPatronal && incidenciasCapturadas[i].nss === captura.nss) {
                                let fecha1 = moment(incidenciasCapturadas[i].fechaIncidencia);
                                let fecha2 = moment(captura.fechaIncidencia);
                                let dias = fecha2.diff(fecha1, 'day');

                                if (dias < incidenciasCapturadas[i].diaAplicado) {
                                    bandera = true;
                                }
                            }
                        }
                        if (bandera === false) {
                            incidenciasCapturadas.push({
                                registroPatronal: rp,
                                tipoIncidencia: captura.tipoIncidencia,
                                nss: captura.nss,
                                fechaIncidencia: captura.fechaIncidencia,
                                folioIncapacidad: captura.folioIncapacidad,
                                diaAplicado: captura.diaAplicado,

                            });
                            this.setState({ indexMovimiento: null, incidenciasCapturadas: incidenciasCapturadas, captura: {} });
                            this.reset();
                        } else {
                            this.growl.show({ severity: 'error', summary: 'Aviso', detail: "No se puede registrar la incidencia porque ya existe con la fecha especificada", life: 3000 });
                        }
                    }
                    this.setState({ indexMovimiento: null, incidenciasCapturadas: incidenciasCapturadas, captura: {} });
                    this.reset();
                } else {
                    this.growl.show({ severity: 'error', summary: 'Aviso', detail: "No se puede registrar la incidencia porque ya existe con la fecha especificada", life: 3000 });
                }
            }).catch(error => {

            });
        }
    }
    reset = () => {
        this.setState({
            mostrarCalendarios: false,

        });
        setTimeout(() => {
            this.setState({ mostrarCalendarios: true });
        }, 50);
    }
    validarFormulario = (captura) => {
        let errores = {};
        var expreReg = /^[A-Z]{2}\d{6}$/;
        var validacionFolio = expreReg.exec(captura.folioIncapacidad);
        if (servicioObjetos.esObjetoVacio(captura.registroPatronal))
            errores.registroPatronal = "Ingrese información requerida";
        if (!servicioObjetos.esObjetoVacio(captura.registroPatronal)) {
            if (servicioObjetos.esObjetoVacio(captura.registroPatronal))
                errores.registroPatronal = "Ingrese información requerida";
        }

        if (servicioObjetos.esObjetoVacio(captura.nss))
            errores.nss = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(captura.tipoIncidencia))
            errores.tipoIncidencia = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(captura.fechaIncidencia))
            errores.fechaIncidencia = "Ingrese información requerida";
        if (captura.tipoIncidencia === "12") {
            if (servicioObjetos.esObjetoVacio(captura.folioIncapacidad))
                errores.folioIncapacidad = "Ingrese información requerida";

            if (!validacionFolio)
                errores.folioIncapacidad = "El folio debe de ser 2 letras y 6 numeros";
        }
        if (servicioObjetos.esObjetoVacio(captura.diaAplicado)) {
            errores.diaAplicado = "Ingrese información requerida";
        } else {
            if (captura.diaAplicado <= 0) {
                errores.diaAplicado = "Los días deben de ser mayores que cero";
            }
        }

        return errores;
    }
    formatofecha = (rowData, column) => {
        return servicioFormatos.formatearFechaStringArchivoIdse(rowData.fechaIncidencia);
    }

    formatoTipoInsidencia = (rowData, column) => {
        return servicioFormatos.formatoTipoIncidencia(rowData.tipoIncidencia);
    }
    onIndexTemplate = (data, props) => {
        let { idsenube } = this.state;
        return (props.rowIndex + 1) + idsenube;
    }
    exportarSua = () => {
        let { incidenciasGuardadas } = this.state;
        if (incidenciasGuardadas.length > 0) {
            servicioArchivos.descargaArchivo('incidencia/generar_sua.json', incidenciasGuardadas);
            this.setState({ incidenciasGuardadas: [], incidenciasCapturadas: [] });
        } else {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: "Guarde las incidencias", life: 3000 });
        }
    }

    guardarSua = () => {
        let { incidenciasCapturadas } = this.state;
        if (incidenciasCapturadas.length > 0) {
            servicioHttp.consumirPostHttp('incidencia/guardar.json', incidenciasCapturadas).then(response => {
                this.setState({ incidenciasGuardadas: response.data.lista });
                if (response.data.error === false) {
                    this.growl.show({ severity: 'success', summary: 'Aviso', detail: "Se guardo la información", life: 3000 });
                } else {
                    this.growl.show({ severity: 'error', summary: 'Aviso', detail: "No se guardo la información", life: 3000 });
                }
            }).catch(error => {

            });
        } else {
            this.growl.show({ severity: 'error', summary: 'Aviso', detail: "Agregue incidentes", life: 3000 });
        }
    }

    render() {
        let { registrosPatronales, captura, errores, incidenciasCapturadas, tiposInsidencias, mostrarCalendarios, trabajadores } = this.state;
        let calendarioIncidencia = <div className="p-col-12 p-md-3 ">
            <Calendar ref={(el) => this.calendario1 = el} id="captura.fechaIncidencia" name="captura.fechaIncidencia" value={captura.fechaIncidencia || ''} onChange={(e) => this.asignarValores(e, false)} style={{ width: "100%" }} dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX}></Calendar>
            {errores.fechaIncidencia ? <Message severity="error" text={errores.fechaIncidencia} /> : null}
        </div>;
        return (
            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <h1>CAPTURAR O EDITAR INCIDENCIAS</h1>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-2">* Registro Patronal:</div>
                                <div className="p-col-12 p-md-6"><Dropdown filter={true} 
                                filterPlaceholder="Filtra por RP o Nombre corto" 
                                filterBy="value,label" showClear={true}
                                appendTo={document.body} id="captura.registroPatronal" 
                                name="captura.registroPatronal" optionLabel="label" 
                                options={registrosPatronales} value={captura.registroPatronal} 
                                onChange={(e) => this.asignarValores(e, false)} autoWidth={false} 
                                style={{ width: "100%" }} className={errores.registroPatronal ? "p-error" : ""} />
                                    {errores.registroPatronal ? <div><Message severity="error" text={errores.registroPatronal} /></div> : null}
                                </div>
                            </div>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-2">* Tipo de Incidencia:</div>
                                <div className="p-col-12 p-md-6">
                                    <Dropdown appendTo={document.body} id="captura.tipoIncidencia" 
                                    name="captura.tipoIncidencia" options={tiposInsidencias} 
                                    value={captura.tipoIncidencia} 
                                    onChange={(e) => { this.asignarValores(e, false) }} 
                                    autoWidth={false} style={{ width: "90%" }} />
                                    {errores.tipoIncidencia ? <div><Message severity="error" text={errores.tipoIncidencia} /></div> : null}
                                </div>
                            </div>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-2">* NSS:</div>
                                <div className="p-col-12 p-md-6"><Dropdown filter={true} 
                                filterBy="label,value" showClear={true} appendTo={document.body} 
                                optionLabel="label" id="captura.nss" name="captura.nss" 
                                options={trabajadores} value={captura.nss} 
                                onChange={(e) => this.asignarValores(e, false)} autoWidth={false} />
                                    {errores.nss ? <Message severity="error" text={errores.nss} /> : null}
                                </div>
                            </div>
                            <div className="p-grid">

                                <div className="p-col-12 p-md-2">* Fecha Incidencia:</div>
                                {mostrarCalendarios ? calendarioIncidencia : null}

                            </div>
                            {captura.tipoIncidencia === "12" ?
                                <div className="p-grid">
                                    <div className="p-col-12 p-md-2">* Folio Incapacidad:</div>
                                    <div className="p-col-12 p-md-6"><InputText type="search" maxLength="8" id="captura.folioIncapacidad" name="captura.folioIncapacidad" value={captura.folioIncapacidad || ""} className={errores.folioIncapacidad ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, true) }} style={{ width: "100%" }} />
                                        {errores.folioIncapacidad ? <Message severity="error" text={errores.folioIncapacidad} /> : null}
                                    </div>
                                </div>
                            : ""}

                            <div className="p-grid">
                                <div className="p-col-12 p-md-2">* Días Aplicados:</div>
                                <div className="p-col-12 p-md-6"><InputText type="search" keyfilter="pint" id="captura.diaAplicado" name="captura.diaAplicado" value={captura.diaAplicado || ""} className={errores.diaAplicado ? "p-error" : ""} onChange={(e) => { this.asignarValores(e, false) }} style={{ width: "100%" }} />
                                    {errores.diaAplicado ? <Message severity="error" text={errores.diaAplicado} /> : null}
                                </div>
                            </div>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3"><Button label="Agregar" icon="pi-md-plus" onClick={this.agregarCapturados} /></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card">
                            <DataTable value={incidenciasCapturadas} header="LISTADO DE INCIDENTES" responsive={true} resizableColumns={true}>
                                <Column body={this.plantillaChecBox} header="Seleccionar" style={{ width: '60px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="Index" header="NO." body={this.onIndexTemplate} style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.formatoTipoInsidencia} header="TIPO" style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="registroPatronal.label" header="REGISTRO PATRONAL" style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="nss" header="NSS" style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.formatofecha} header="FECHA" style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="folioIncapacidad" header="FOLIO" style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                                <Column field="diaAplicado" header="DIAS" style={{ width: '50px' }} autoLayout={true} resizableColumns={true} />
                            </DataTable>
                        </div>
                    </div>
                </div>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-3">
                        <Button label="Editar" onClick={this.editarDatos} icon="pi-md-mode-edit" />
                    </div>
                    <div className="p-col-12 p-md-3">
                        <Button label="Eliminar" onClick={this.eliminarDelaListaCaptura} icon="pi-md-delete" />
                    </div>
                    <div className="p-col-12 p-md-3">
                        <Button label="Guardar" onClick={this.guardarSua} icon="pi-md-save" />
                    </div>
                    <div className="p-col-12 p-md-3">
                        <Button label="Exportar SUA" onClick={this.exportarSua} icon="pi-md-import-export" />
                    </div>
                </div>
            </div>
        );
    }
}